import { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import FAQAccordion from "../components/faq_accordion";

import "../styles/products_returns.css";

class ProductCancellationScreen extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { isLoggedIn } = this.props;
    // 1. For FAQ Accordion
    const cancellationFaqs = [
      {
        id: "cancel1",
        question:
          "If it's been 30 minutes, can I contact XLP to help cancel my order?",
        answer:
          "Unfortunately, after 30 minutes even we are unable to cancel an order, but you can return or exchange the order after it arrives.",
      },
      {
        id: "cancel2",
        question: "How do refunds work for canceled orders?",
        answer:
          "We don’t charge your payment until the order ships. If you cancel an order, you won’t be charged, so you won’t need to be refunded. You might see an initial authorization for the order total—this is a temporary hold on funds that will automatically drop off within a few days.",
      },
      {
        id: "cancel3",
        question: "Can I change the shipping address on my order?",
        answer:
          "No, our team moves quickly to process and ship your order—we cannot change your delivery address. However, after your order ships, you can contact the carrier directly to see if they can update the address or redirect the package to a pickup facility.",
      },
      {
        id: "cancel4",
        question: "Can I change the shipping address on my XLP By You order?",
        answer:
          "Depending on the status of your custom order, we may be able to change your XLP By You delivery address.",
      },
    ];

    return (
      <>
        <Header isLoggedIn={isLoggedIn} />

        {/* 2. HERO BANNER */}
        <section className="page-banner py-5">
          <div className="container">
            <h1 className="mb-0">Order Cancellation</h1>
          </div>
        </section>

        {/* 3. POLICY CONTENT */}
        <section className="policy-content py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-9">
                <div className="policy-text-block mb-5">
                  <h2>Can I Cancel or Change My XLP Order?</h2>
                  <p>
                    You can't make changes to an order, but you can cancel it
                    within 30 minutes of placing it.
                  </p>
                  <p>To cancel an order:</p>

                  <ul className="policy-list">
                    <li>
                      If you're a XLP Member, sign in to open your order (or
                      navigate to your orders page if you're already signed in).
                    </li>
                    <li>
                      Tap or click "View or Manage" for the order you want to
                      cancel.
                    </li>
                    <li>
                      Tap or click the "Cancel Order" button and follow the
                      prompts.
                    </li>
                  </ul>

                  <p>
                    Guests will need to enter their order number and email
                    address and then look for the "Cancel Order" button. If you
                    don't see the cancel button, your order is no longer
                    eligible to be canceled. After 30 minutes, even our XLP
                    representatives cannot cancel the order. But don't
                    worry—once the items arrive you can return or exchange them.
                  </p>
                </div>

                <hr className="policy-divider my-5" />

                {/* 4. FAQ SECTION */}
                <div className="faq-section mb-5">
                  <h2 className="mb-4">FAQs</h2>

                  {/* Data Array wrt to FAQ Accordion */}
                  <FAQAccordion faqs={cancellationFaqs} />
                </div>

                {/* 5. CONCLUDING TEXT */}
                <p
                  className="mt-5 text-secondary"
                  style={{ fontSize: "15px", lineHeight: "1.6" }}
                >
                  Unfortunately changes of any kind are not possible, including
                  changing an item's color, size, or quantity, your shipping
                  selection, or your delivery address. If it's still within 30
                  minutes of placing your order, your best bet is to cancel the
                  order and place a new one.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </>
    );
  }
}

export default ProductCancellationScreen;
